/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './hover-menu.scss';

class HoverMenu extends Component {
    state = {
        show: false,
        hoverContainer: false
    };

    toggleShow = show => {
        window.clearTimeout(this.toggleShowTimeoutId);
        this.toggleShowTimeoutId = window.setTimeout(() => {
            if (this.state.show !== show) {
                this.setState({ show: show });
            }
        }, 100);
    };

    componentDidUpdate(prevProps) {
        if (this.props.showMenu !== prevProps.showMenu) {
            this.toggleShow(this.props.showMenu);
        }
    }

    render() {
        const { children, className = '' } = this.props;

        return (
            this.state.show && (
                <div className={`hover-menu-container ${className}`}>
                    <nav className="hover-menu-area">
                        <ul className="hover-menu-area-content list-unstyled">
                            {children}
                        </ul>
                    </nav>
                </div>
            )
        );
    }
}

HoverMenu.propTypes = {
    showMenu: PropTypes.bool,
    className: PropTypes.string
};

export default HoverMenu;
